<template>
    <div class="first-time-modal">
      <modal-header
          :logo-img-src="require('@/assets/image/homebase/aone_logo.svg')"
          :on-modal-close="close"
      ></modal-header>
      <div class="d-flex justify-content-center pt-3 pb-5">
        <div class="modal-body text-center">
          <div class="modal-description pb-4">
            <div v-html="this.removeInheritedStyles(this.campaignData.Copy)"></div>
          </div>
          <div style="max-width: 640px">
            <div>
              <video controls :poster="this.campaignData.GIFURL.Url">
                <source
                    :src="this.campaignData.VideoURL.Url"
                    type="video/mp4"
                />
              </video>
            </div>
          </div>
        </div>
      </div>
      <modal-footer
          class="text-center"
          :buttonConfigs="[buttonConfig]"
      ></modal-footer>
    </div>
  </template>
  
  <script>
  import ModalHeader from "./ModalHeader";
  import ModalFooter from "./ModalFooter";
  import * as CONSTANTS from "@/store/constants";
  import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";
  import LocalStorageMixin from "@/mixins/LocalStorageMixin";
  
  export default {
    name: "one-mobile-modal",
    mixins: [HomebaseMixpanelMixin, LocalStorageMixin],
    components: {
      ModalHeader,
      ModalFooter,
    },
    data() {
      return {
        buttonConfig: {
          text: this.campaignData.CalloutAction.Description,
          clickHandler: this.done,
          class: "homebase-btn-primary",
        },
      };
    },
    props: {
      campaignData: Object
    },
    methods: {
      close() {
        this.setFlag(CONSTANTS.VIDEO_POPUP_CAMPAIGN_FIRST_TIME_VISIT_KEY, this.campaignData.LocalStorageKey, true);
        this.$emit("close");
      },
      done() {
        this.trackOneMobilePilotClick();
        this.setFlag(CONSTANTS.VIDEO_POPUP_CAMPAIGN_FIRST_TIME_VISIT_KEY, this.campaignData.LocalStorageKey, true);
        window.open(this.campaignData.CalloutAction.Url, "_blank");
        this.$emit("close");
      },
      removeInheritedStyles(htmlString) {
        const $html = $(htmlString);
        $html.find('[style]').removeAttr('style');
        return $('<div>').append($html).html();
      }
    },
  };
  </script>
  
  <style scoped>
  .welcome-msg {
    font-size: 24px;
  }
  .modal-text-bold {
    font-family: artifaktElementBold !important;
  }
  .modal-description {
    font-size: 18px;
    text-align: justify;
  }
  .modal-body {
    max-width: 480px;
    min-height: 400px;
  }
  .aone-logo {
    width: 80%;
    margin-top: -6px;
  }
  video {
    width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
  </style>
  
  <style>
  /* only increase overlay opacity for this modal */
  .v--modal-overlay:has(.first-time-modal) {
    background: rgba(0, 0, 0, 0.5);
  }
  </style>


// WEBPACK FOOTER //
// src/components/homebase/modals/OneMobileModal.vue